module.exports = require("@agm/core/services/fit-bounds");